import CryptoJS from 'crypto-js';

// WARNING: This key is embedded in the client-side code.
// Replace with a strong, unique key, ideally loaded from environment variables.
const SECRET_KEY = process.env.REACT_APP_ENCRYPTION_KEY || 'YOUR_VERY_SECRET_KEY_REPLACE_ME';

export const encryptData = (data) => {
  if (typeof data !== 'string') {
    data = JSON.stringify(data);
  }
  return CryptoJS.AES.encrypt(data, SECRET_KEY).toString();
};

export const decryptData = (ciphertext) => {
  if (!ciphertext) return null;
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    // Attempt to parse if it was originally an object, otherwise return as string
    try {
      return JSON.parse(decryptedString);
    } catch (e) {
      return decryptedString;
    }
  } catch (error) {
    console.error('Decryption failed:', error);
    return null;
  }
};
